import { Divider, Flex, Layout } from "antd";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { AppLayoutSidebarTrigger } from "@/modules/app-layout/app-layout-sidebar-trigger";
import { NavButtonAbout } from "@/modules/nav-button-about";
import { NavButtonLink } from "@/modules/nav-button-link";
import { NavButtonNotifications } from "@/modules/nav-button-notifications";
import { OrganizationContextHeader } from "@/modules/organization/organization-context-header";
import { UserDropdownMenu } from "@/modules/user-dropdown-menu";
import { useThemeBreakpoints } from "@/services/theme";
import { AppLogo } from "@/ui/app-logo";

import { useAppLayoutHeaderSizes } from "./app-layout-header.hook";

import "./app-layout-header.style.less";

const { Header } = Layout;

export const AppLayoutHeader = () => {
  const { t } = useTranslation();
  const { isXs } = useThemeBreakpoints();
  const { cssVars, logoContainerWidth, organizationDropdownPosition } =
    useAppLayoutHeaderSizes();

  return (
    <Header className={classNames("app-layout-header", { "-xs": isXs })}>
      <style>{`.stelar{${cssVars}}`}</style>
      <Flex
        gap="small"
        style={{ flex: `0 0 ${logoContainerWidth}px` }}
        className="app-layout-header-logo"
      >
        {isXs && <AppLayoutSidebarTrigger />}
        <AppLogo withLink />
      </Flex>
      <Divider vertical className="app-layout-header-divider" />
      <div className="app-layout-header-organization">
        <OrganizationContextHeader
          dropdownPosition={organizationDropdownPosition}
        />
      </div>
      <div className="app-layout-header-menu">
        <NavButtonNotifications />
        <NavButtonLink linkKey="support" title={t("global:helpCenter.link")} />
        <NavButtonAbout title={t("global:about.title")} />
        <UserDropdownMenu />
      </div>
    </Header>
  );
};
